"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
exports.Features = {
    Hub: 'hub',
    FreeRotation: 'free_rotation',
    BeatingHeart: 'beating_heart',
    Publicity: 'publicity',
    AutoSync: 'auto_sync',
    ModelUpdates: 'model_updates',
    PushNotifications: 'push_notifications',
};
